"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _commonHelper = require("../helpers/commonHelper");
var _Navbar = require("./Navbar");
var _uniqueIdHelper = _interopRequireDefault(require("../helpers/uniqueIdHelper"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var navId = (0, _uniqueIdHelper["default"])("navigation");
var headerHeight = "7.2rem";
var maxContentWidth = "90rem";
var largeMaxContentWidth = "110rem";
var extraLargeMaxContentWidth = "124rem";
var Header = function Header(props) {
  var logoImg = props.logoImg,
    LogoComponent = props.LogoComponent,
    absolute = props.absolute,
    transparent = props.transparent,
    ActiveMobileLogoComponent = props.ActiveMobileLogoComponent,
    activeMobileLogoImg = props.activeMobileLogoImg,
    onLogoClick = props.onLogoClick,
    logoHeight = props.logoHeight,
    isLogoCentered = props.isLogoCentered,
    isMobLogoCentered = props.isMobLogoCentered,
    showMenu = props.showMenu,
    large = props.large,
    extraLarge = props.extraLarge;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isMenuOpened = _useState2[0],
    toggleMenuOpen = _useState2[1];
  var isTransparent = !!transparent;
  var headerRef = (0, _react.useRef)(null);
  var delayedToggle = function delayedToggle() {
    typeof setTimeout == "function" && setTimeout(function () {
      toggleMenuOpen(false);
    }, _misc["default"].navToggleDurationInMS);
  };
  var children = _react["default"].Children.count(props.children) > 1 ? _react["default"].Children.map(props.children, function (child, index) {
    return child && (0, _commonHelper.mapProps)(child, {
      index: index,
      open: isMenuOpened,
      navId: navId,
      isTransparent: isTransparent,
      toggleMenuOpen: delayedToggle
    });
  }) : (0, _commonHelper.mapProps)(props.children, {
    open: isMenuOpened,
    navId: navId,
    isTransparent: isTransparent,
    toggleMenuOpen: delayedToggle
  });
  var toggleMobileMenu = function toggleMobileMenu() {
    toggleMenuOpen(!isMenuOpened);
  };
  return /*#__PURE__*/_react["default"].createElement(Header.wrapper, {
    isTransparent: isTransparent,
    open: isMenuOpened,
    absolute: absolute
  }, /*#__PURE__*/_react["default"].createElement(Header.Element, {
    large: large,
    extraLarge: extraLarge
  }, /*#__PURE__*/_react["default"].createElement(MobileHeader, {
    isTransparent: isTransparent,
    open: isMenuOpened
  }, showMenu && /*#__PURE__*/_react["default"].createElement(MobileHeader.Ele, {
    ref: headerRef
  }, /*#__PURE__*/_react["default"].createElement(_Navbar.MenuIcon, {
    "aria-label": "Menu",
    "aria-controls": navId,
    "aria-expanded": isMenuOpened,
    role: "button",
    open: isMenuOpened,
    onClick: toggleMobileMenu,
    tabIndex: "0",
    isTransparent: isTransparent
  })), /*#__PURE__*/_react["default"].createElement(MobileHeader.Ele, {
    centered: isMobLogoCentered
  }, ActiveMobileLogoComponent === null ? /*#__PURE__*/_react["default"].createElement(Header.mobileLogo, {
    src: isMenuOpened && activeMobileLogoImg ? activeMobileLogoImg : logoImg,
    tabIndex: 0,
    onClick: onLogoClick
  }) : /*#__PURE__*/_react["default"].createElement(Header.mobileLogoWrapper, {
    onClick: onLogoClick
  }, isMenuOpened ? ActiveMobileLogoComponent : LogoComponent))), /*#__PURE__*/_react["default"].createElement(LogoPositioner, {
    isCentered: isLogoCentered
  }, LogoComponent === null ? /*#__PURE__*/_react["default"].createElement(Header.Logo, {
    logoHeight: logoHeight,
    src: logoImg,
    tabIndex: "0",
    onClick: onLogoClick
  }) : /*#__PURE__*/_react["default"].createElement(Header.LogoWrapper, {
    onClick: onLogoClick
  }, LogoComponent)), children));
};
var LogoPositioner = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-yvzia9-0"
})(["", ""], function (props) {
  return props.isCentered && (0, _styledComponents.css)(["position:absolute;left:50%;transform:translateX(-50%);"]);
});
var getBGColor = function getBGColor(props) {
  return props.isTransparent && props.open ? "".concat(_white["default"]) : "transparent";
};
var getMaxWidth = function getMaxWidth(props) {
  if (props.extraLarge) {
    return extraLargeMaxContentWidth;
  }
  if (props.large) {
    return largeMaxContentWidth;
  }
  return maxContentWidth;
};
Header.wrapper = _styledComponents["default"].header.withConfig({
  componentId: "sc-yvzia9-1"
})(["width:100%;max-width:100%;display:block;position:", ";height:", ";justify-content:space-between;align-items:center;top:0;transition:opacity 0.25s linear,height 0.56s cubic-bezier(0.52,0.16,0.24,1);background-color:transparent;@media (min-width:768px) and (max-width:900px){&{padding:0 1.5rem;}}"], function (props) {
  return props.absolute ? "absolute" : "static";
}, headerHeight);
Header.Element = _styledComponents["default"].nav.withConfig({
  componentId: "sc-yvzia9-2"
})(["width:100%;max-width:", ";padding-right:", ";margin:0 auto;display:flex;flex-wrap:nowrap;height:100%;justify-content:space-between;align-items:center;position:relative;z-index:4;"], getMaxWidth, function (props) {
  return props.extraLarge ? "5.4rem" : "0";
});
var MobileHeader = /*#__PURE__*/_styledComponents["default"].ul.withConfig({
  componentId: "sc-yvzia9-3"
})(["display:none;height:", ";overflow:hidden;position:absolute;width:100%;margin:0;padding:0 1.5rem;background:", ";@media screen and (max-width:768px){&{display:flex;justify-content:space-between;z-index:4;}}"], headerHeight, getBGColor);
MobileHeader.Ele = _styledComponents["default"].li.withConfig({
  componentId: "sc-yvzia9-4"
})(["display:none;z-index:2;height:100%;width:auto;display:flex;flex-grow:", ";border-bottom:none;align-items:center;justify-content:center;"], function (props) {
  return props.centered ? 1 : 0;
});
Header.LogoWrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-yvzia9-5"
})(["max-width:14rem;height:2.7rem;display:block;cursor:pointer;&:focus{outline:", ";}@media screen and (max-width:768px){&{display:none;}}"], _misc["default"].genericOutline);
Header.Logo = _styledComponents["default"].img.withConfig({
  componentId: "sc-yvzia9-6"
})(["max-width:14rem;height:", ";display:block;cursor:pointer;&:focus{outline:", ";}@media screen and (max-width:768px){&{display:none;}}"], function (props) {
  return props.logoHeight;
}, _misc["default"].genericOutline);
Header.mobileLogo = (0, _styledComponents["default"])(Header.Logo).withConfig({
  componentId: "sc-yvzia9-7"
})(["display:none;@media screen and (max-width:768px){&{display:block;cursor:pointer;}}"]);
Header.mobileLogoWrapper = (0, _styledComponents["default"])(Header.LogoWrapper).withConfig({
  componentId: "sc-yvzia9-8"
})(["display:none;@media screen and (max-width:768px){&{display:block;cursor:pointer;}}"]);
Header.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  /** Url for logo image, will be hidden if you pass LogoComponent  */
  logoImg: _propTypes["default"].string,
  /** Pass the function for rendering logo component if its not a simple image */
  LogoComponent: _propTypes["default"].node,
  transparent: _propTypes["default"].bool,
  /** Url for Mobile logo image, will be hidden if you pass LogoComponent, Usually dark colored image  */
  activeMobileLogoImg: _propTypes["default"].string,
  /** Pass Mobile logo component if its not a simple image */
  ActiveMobileLogoComponent: _propTypes["default"].node,
  bgColor: _propTypes["default"].string,
  absolute: _propTypes["default"].bool,
  /** What to do on Logo click/tap : usually takes user to home page */
  onLogoClick: _propTypes["default"].func,
  logoHeight: _propTypes["default"].string,
  isLogoCentered: _propTypes["default"].bool,
  large: _propTypes["default"].bool,
  showMenu: _propTypes["default"].bool,
  isMobLogoCentered: _propTypes["default"].bool,
  extraLarge: _propTypes["default"].bool
};
Header.defaultProps = {
  logoImg: null,
  LogoComponent: null,
  bgColor: _white["default"],
  transparent: false,
  absolute: false,
  ActiveMobileLogoComponent: null,
  activeMobileLogoImg: null,
  onLogoClick: null,
  logoHeight: "2.7rem",
  isLogoCentered: false,
  large: false,
  showMenu: true,
  isMobLogoCentered: false,
  extraLarge: false
};
var _default = exports["default"] = Header;